"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5160],{

/***/ 95790:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "pl": function() { return /* reexport */ OtherPaymentMethods; },
  "KR": function() { return /* reexport */ isPaymentMethodDataOneClick; }
});

// UNUSED EXPORTS: AssistantVendorPaymentMethods, LocalVendorPaymentMethods

;// CONCATENATED MODULE: ./src/interfaces/paymentMethod.interface.ts
/*
 * File: paymentMethod.interface.ts
 * Project: meki
 * File Created: Monday, 5th October 2020 4:53:04 pm
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Thursday, 20th October 2022 12:07:53 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var OtherPaymentMethods;
(function(OtherPaymentMethods) {
    OtherPaymentMethods["FINTOC"] = "Fintoc";
    OtherPaymentMethods["BANCO_ESTADO"] = "BancoEstado";
})(OtherPaymentMethods || (OtherPaymentMethods = {}));
function isPaymentMethodDataOneClick(data) {
    return typeof data === "object" && data !== null && "tbkUser" in data;
}

;// CONCATENATED MODULE: ./src/interfaces/order.interface.ts
/*
 * File: order.interface.ts
 * Project: meki
 * File Created: Wednesday, 21st October 2020 8:51:58 am
 * Author: Vicente Melin (vicente@inventures.cl)
 * -----
 * Last Modified: Monday, 19th June 2023 9:56:11 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ var LocalVendorPaymentMethods;
(function(LocalVendorPaymentMethods) {
    LocalVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    LocalVendorPaymentMethods["CARD_CASH"] = "CARD_CASH";
    LocalVendorPaymentMethods["CARD"] = "CARD";
    LocalVendorPaymentMethods["CASH"] = "CASH";
})(LocalVendorPaymentMethods || (LocalVendorPaymentMethods = {}));
var AssistantVendorPaymentMethods;
(function(AssistantVendorPaymentMethods) {
    AssistantVendorPaymentMethods["TRANSFER"] = "TRANSFER";
    AssistantVendorPaymentMethods["CARD"] = "CARD";
})(AssistantVendorPaymentMethods || (AssistantVendorPaymentMethods = {}));

;// CONCATENATED MODULE: ./src/interfaces/index.ts
/*
 * File: index.ts
 * Project: meki
 * File Created: Monday, 21st September 2020 5:35:28 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 3rd February 2023 9:38:17 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 























/***/ }),

/***/ 50952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ assignPaymentMethod; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57800);
/*
 * File: assignPaymentMethod.tsx
 * Project: meki
 * File Created: Friday, 16th April 2021 7:56:49 am
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Thursday, 11th November 2021 3:50:32 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation checkoutAssignPaymentMethod($params: AssignPaymentMethodParams!) {\n    assignPaymentMethod(params: $params) {\n      id\n      uuid\n      paymentMethod {\n        id\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var assignPaymentMethod = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 45482:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ OrderDeliveryOptions; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57800);
/*
 * File: detail.ts
 * Project: meki
 * File Created: Wednesday, 10th November 2021 4:58:00 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 1st December 2023 11:26:50 am
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query OrderDeliveryOptions($params: OrderDeliveryOptionsParams!) {\n    orderDeliveryOptions(params: $params) {\n      dates\n      currentOrderId\n      deliveryCost\n      orders {\n        deliveryDate\n        deliveryType\n        deliveryCost\n        deliveryCoupon\n        totalCost\n        orderDetails {\n          quantity\n          product {\n            id\n            name\n            imagesUrl\n            activePrinciple\n            concentration\n            unit\n            prescriptionType\n            quantity\n            discount {\n              price\n              type\n              stockRestriction\n              dateRestriction\n              listPrice\n            }\n            format\n            price\n            container\n            containerQuantity\n            concentration\n            laboratory\n            availability {\n              stock\n              statusWithoutStock\n              status\n            }\n            metadata {\n              refrigerated\n            }\n          }\n          price\n          type\n          listPrice\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var OrderDeliveryOptions = function() {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject());
};


/***/ }),

/***/ 66860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ finishOneClickInscription; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57800);
/*
 * File: finishOneClickInscription.ts
 * Project: meki
 * File Created: Tuesday, 27th October 2020 12:53:23 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 22nd July 2022 3:30:59 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  mutation ",
        " ($params: FinishOneClickInscriptionParams!) {\n    finishOneClickInscription(params: $params) {\n      id\n      uuid\n      type\n      data\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var finishOneClickInscription = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 50018:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ getOneClickRedirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92228);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57800);
/*
 * File: getOneClickRedirect.ts
 * Project: meki
 * File Created: Tuesday, 27th October 2020 12:53:23 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Monday, 21st December 2020 3:20:19 pm
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  query ",
        " ($params: GetRedirectUrlOneClickParams!) {\n    getRedirectUrlOneClick(params: $params) {\n      url\n      token\n      method\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var getOneClickRedirect = function(name) {
    return (0,_apollo_client__WEBPACK_IMPORTED_MODULE_1__/* .gql */ .Ps)(_templateObject(), name);
};


/***/ }),

/***/ 55678:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ CardIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(683);
/* harmony import */ var _paymentMethod_components_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96966);
/* harmony import */ var _components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(27064);
/* harmony import */ var _components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1991);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_5__);






function CardIcon(props) {
    var icon;
    switch(props.creditCardType){
        case "Visa":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_VisaIcon__WEBPACK_IMPORTED_MODULE_1__/* .VisaIcon */ .Q, {});
            break;
        case "MasterCard":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_MasterCardIcon__WEBPACK_IMPORTED_MODULE_3__/* .MasterCardIcon */ .s, {});
            break;
        case "RedCompra":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_icons_RedCompraIcon__WEBPACK_IMPORTED_MODULE_4__/* .RedCompraIcon */ .b, {});
            break;
        case "Fintoc":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/fintoc.svg",
                alt: "bankIcon",
                height: 22,
                width: 22
            });
            break;
        case "BancoEstado":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/bancoEstadoLogo.png",
                alt: "bancoEstadoLogo",
                height: 30,
                width: 30
            });
            break;
        case "Credits":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/credits.svg",
                alt: "creditsIcon",
                height: 22,
                width: 22
            });
            break;
        case "Insurance":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/insurance.svg",
                alt: "insuranceIcon",
                height: 22,
                width: 22
            });
            break;
        case "NewInsurance":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/newInsurance.svg",
                alt: "newInsuranceIcon",
                height: 22,
                width: 22
            });
            break;
        case "NewCard":
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/newCard.svg",
                alt: "newCardIcon",
                height: 22,
                width: 22
            });
            break;
        default:
            icon = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_5___default()), {
                src: "/assets/images/cardIcon.png",
                alt: "cardIcon",
                height: 30,
                width: 30
            });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_paymentMethod_components_PaymentsOptions_styles__WEBPACK_IMPORTED_MODULE_2__/* .CardIconContainer */ .gM, {
        children: icon
    });
}


/***/ }),

/***/ 96966:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ey": function() { return /* binding */ SkeletonOptionDescriptionText; },
/* harmony export */   "GF": function() { return /* binding */ ArrowIconContainer; },
/* harmony export */   "I3": function() { return /* binding */ OptionTitleText; },
/* harmony export */   "PM": function() { return /* binding */ InstallmentsText; },
/* harmony export */   "Qc": function() { return /* binding */ PaymentOptionSubSection; },
/* harmony export */   "TR": function() { return /* binding */ NewTagContainer; },
/* harmony export */   "cS": function() { return /* binding */ OptionRightContainer; },
/* harmony export */   "cu": function() { return /* binding */ SkeletonOptionTitleText; },
/* harmony export */   "ex": function() { return /* binding */ OptionDescriptionText; },
/* harmony export */   "gM": function() { return /* binding */ CardIconContainer; },
/* harmony export */   "o3": function() { return /* binding */ NewCardLoaderContainer; },
/* harmony export */   "ox": function() { return /* binding */ OptionLeftContainer; },
/* harmony export */   "q4": function() { return /* binding */ OptionDiv; },
/* harmony export */   "rk": function() { return /* binding */ TextDiv; }
/* harmony export */ });
/* unused harmony exports RadioInput, AddOptionText, RadioInputSkeleton, ErrorTypography */
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13264);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91655);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29630);


var PaymentOptionSubSection = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    gap: "8px"
});
var OptionDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div", {
    shouldForwardProp: function(prop) {
        return prop !== "quoteLoading";
    }
})(function(param) {
    var quoteLoading = param.quoteLoading;
    return {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "16px 8px 16px 16px",
        cursor: quoteLoading ? "default" : "pointer !important",
        opacity: quoteLoading ? 0.5 : 1
    };
});
var OptionLeftContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px"
});
var OptionRightContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "flex-end",
    gap: "4px"
});
var NewTagContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    backgroundColor: "#73A9FF",
    color: "white",
    borderRadius: "12px",
    padding: "0 8px",
    fontSize: "12px"
});
var RadioInput = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("input")({
    cursor: "pointer",
    WebkitAppearance: "none",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    outline: "none",
    border: "2px solid #0277BD",
    ":before": {
        content: '""',
        display: "block",
        width: "60%",
        height: "60%",
        margin: "20% auto",
        borderRadius: "50%"
    },
    ":checked:before": {
        backgroundColor: "#0277BD"
    }
});
var RadioInputSkeleton = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "20px",
    height: "30px"
});
var TextDiv = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column"
});
var OptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var InstallmentsText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "300",
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#919191",
    "> span": {
        marginLeft: "5px",
        color: "#414046",
        fontWeight: "500"
    }
});
var SkeletonOptionTitleText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "120px",
    height: "20px"
});
var OptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
    shouldForwardProp: function(prop) {
        return prop !== "light";
    }
})(function(param) {
    var light = param.light;
    return {
        fontFamily: "Poppins",
        fontWeight: light ? "300" : "500",
        fontSize: "12px",
        lineHeight: "18px",
        letterSpacing: "0.16px",
        color: "#919191"
    };
});
var SkeletonOptionDescriptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
    width: "80px",
    height: "20px"
});
var AddOptionText = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    marginLeft: "27px"
});
var ErrorTypography = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
    fontFamily: "Poppins",
    fontWeight: 500,
    fontSize: "12px",
    lineHeight: "16px",
    letterSpacing: "0.15px",
    color: "#D32F2F",
    marginTop: "6px",
    marginBottom: "6px"
});
var CardIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px",
    borderRadius: "50%",
    backgroundColor: "#EAEAEA"
});
var ArrowIconContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "35px",
    height: "35px"
});
var NewCardLoaderContainer = (0,_mui_system__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div")({
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#FFFFFF",
    justifyContent: "center",
    marginRight: "5px",
    borderRadius: "10px",
    zIndex: 1
});



/***/ }),

/***/ 91060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "C": function() { return /* binding */ PaymentsOptions; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(66383);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(45680);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useMutation.js
var useMutation = __webpack_require__(50319);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/queries/checkout/mutations/assignPaymentMethod.tsx
var assignPaymentMethod = __webpack_require__(50952);
// EXTERNAL MODULE: ./src/hooks/useOrderState.tsx
var useOrderState = __webpack_require__(778);
// EXTERNAL MODULE: ./src/utils/index.ts + 3 modules
var utils = __webpack_require__(8881);
// EXTERNAL MODULE: ./src/utils/formatters/CurrencyFormatter.ts
var CurrencyFormatter = __webpack_require__(23239);
// EXTERNAL MODULE: ./src/config/environment.ts
var environment = __webpack_require__(60031);
// EXTERNAL MODULE: ./node_modules/@mui/system/esm/styled.js
var styled = __webpack_require__(13264);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/styles/LocalPaymentOptions.styles.ts


var RootDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    flexDirection: "column",
    margin: "12px 0 0 0",
    backgroundColor: "#FFFFFF",
    padding: "12px 15px",
    border: "1px solid #EAEAEA",
    borderRadius: "10px"
});
var AddOptionText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#0A7ABE",
    marginLeft: "27px"
});
var LocalTitleText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "16px",
    lineHeight: "24px",
    letterSpacing: "0.15px",
    color: "#414046"
});
var SelectPayment = (0,styled/* default */.Z)("select")({
    maxWidth: "306px",
    height: "40px",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#757475",
    padding: "7px 0 7px 10px"
});
var SelectPaymentOption = (0,styled/* default */.Z)("option")({
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#757475",
    padding: "7px 0 7px 10px",
    cursor: "pointer",
    "&:hover": {
        backgroundColor: "#0A7ABE",
        color: "black"
    }
});
var TransferDiv = (0,styled/* default */.Z)("div")({
    backgroundColor: "#F9F9F9",
    padding: "15px 12px",
    maxWidth: "304px",
    marginTop: "10px"
});
var TransferTitleText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "14px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    marginBottom: "6px"
});
var TransferText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046"
});
var MixDiv = (0,styled/* default */.Z)("div")({
    display: "flex",
    maxWidth: "304px",
    flexDirection: "row",
    marginTop: "10px",
    alignItems: "center",
    justifyContent: "space-between"
});
var MixText = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#414046"
});
var MixInput = (0,styled/* default */.Z)("input")({
    maxWidth: "152px",
    padding: "10px",
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.15px",
    color: "#414046",
    textAlign: "right"
});
var MixAmount = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    fontWeight: "500",
    fontSize: "13px",
    lineHeight: "19.5px",
    letterSpacing: "0.16px",
    color: "#757475"
});
var TotalTypography = (0,styled/* default */.Z)(Typography/* default */.Z)({
    fontFamily: "Poppins",
    marginTop: "10px",
    marginLeft: "5px",
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "18px",
    letterSpacing: "0.16px",
    color: "#757475",
    textAlign: "right"
});


;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/TransferDiv.tsx


var TransferDivComponent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TransferDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferTitleText, {
                children: "Datos transferencia"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Nombre: MEDICAL KIT SPA"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "RUT: 77.143.138-0"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Banco: BCI"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Cuenta Cte N\xb0: 46193499"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferText, {
                children: "Correo electr\xf3nico: PAGOS@MIMEKI.CL"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/localPaymentOptionsStore.tsx
var localPaymentOptionsStore = __webpack_require__(57500);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Divider/Divider.js
var Divider = __webpack_require__(44373);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/LocalPaymentOptions.tsx







function LocalPaymentOptions(props) {
    var changePaymentAmount = props.changePaymentAmount;
    var ref = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)(), paymentOption = ref.paymentOption, mixPayments = ref.mixPayments;
    var setPaymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setPaymentOption;
    var handleOnChange = function(item) {
        setPaymentOption(item);
    };
    var currFormat = new CurrencyFormatter/* CurrencyFormatter */.J({
        fallback: environment/* NEXT_PUBLIC_NO_PRICE_FALLBACK */.uh
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTitleText, {
                children: "M\xe9todos de pago"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPayment, {
                onChange: function(item) {
                    return handleOnChange(item.target.value);
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "none",
                        selected: true,
                        disabled: true,
                        hidden: true,
                        children: "Seleccionar m\xe9todo de pago"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CASH",
                        children: "Efectivo"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD",
                        children: "Tarjeta"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "TRANSFER",
                        children: "Transferencia"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD_CASH",
                        children: "Efectivo + Tarjeta"
                    })
                ]
            }),
            paymentOption === "TRANSFER" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferDivComponent, {}),
            paymentOption === "CARD_CASH" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MixDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixText, {
                                children: "Efectivo"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixInput, {
                                value: mixPayments.CASH,
                                onChange: function(event) {
                                    return changePaymentAmount(event);
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(MixDiv, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixText, {
                                children: "Tarjeta"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(MixAmount, {
                                children: currFormat.format(mixPayments.CARD)
                            })
                        ]
                    })
                ]
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/usePermissions.tsx + 1 modules
var usePermissions = __webpack_require__(18782);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.styles.ts
var PaymentsOptions_styles = __webpack_require__(96966);
// EXTERNAL MODULE: ./src/interfaces/index.ts + 2 modules
var interfaces = __webpack_require__(95790);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/ArrowForwardIosRounded.js
var ArrowForwardIosRounded = __webpack_require__(47111);
// EXTERNAL MODULE: ./src/screens/payment/methods/hooks/useOneClickRedirect.ts
var useOneClickRedirect = __webpack_require__(43472);
// EXTERNAL MODULE: ./src/screens/checkout/components/CardIcon.tsx
var CardIcon = __webpack_require__(55678);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/zustand/paymentMethodStore.tsx
var paymentMethodStore = __webpack_require__(69355);
// EXTERNAL MODULE: ./src/screens/checkout/paymentConfirm/components/ErrorModal.tsx + 1 modules
var ErrorModal = __webpack_require__(70276);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/CircularProgress/CircularProgress.js + 1 modules
var CircularProgress = __webpack_require__(70754);
// EXTERNAL MODULE: ./src/screens/checkout/paymentMethod/styles.ts
var styles = __webpack_require__(52595);
// EXTERNAL MODULE: ./src/hooks/useEventTracking.tsx + 1 modules
var useEventTracking = __webpack_require__(66630);
// EXTERNAL MODULE: ./src/validators/Events/Interactions/index.ts + 5 modules
var Interactions = __webpack_require__(40813);
;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentMethods.tsx















function PaymentMethods(param) {
    var loading = param.loading, handleSelect = param.handleSelect, quoteLoading = param.quoteLoading;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isAssistantUser = userCan("MANAGE_USER");
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var ref = (0,react.useState)(false), error = ref[0], setError = ref[1];
    var ref1 = (0,react.useState)(false), loadingOneClick = ref1[0], setLoadingOneClick = ref1[1];
    var handleShowError = function() {
        setError(true);
    };
    var ref2 = (0,_sliced_to_array/* default */.Z)((0,useOneClickRedirect/* useOneClickRedirect */.O)("/checkout/metodo-pago", handleShowError), 1), redirectToOneClick = ref2[0];
    var paymentMethods = (0,paymentMethodStore/* useOrderAndPaymentInfo */.oF)().paymentMethods;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PaymentMethodMainCard */.Z, {
                children: [
                    loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionLeftContainer */.ox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* CardIconContainer */.gM, {}),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* SkeletonOptionTitleText */.cu, {}),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* SkeletonOptionDescriptionText */.Ey, {})
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                            color: "primary"
                                        })
                                    })
                                ]
                            }, 0),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                        ]
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: paymentMethods === null || paymentMethods === void 0 ? void 0 : paymentMethods.map(function(paymentMethod) {
                            if ((0,interfaces/* isPaymentMethodDataOneClick */.KR)(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.data)) {
                                var ref;
                                var data = paymentMethod.data;
                                var typeCapitalize = paymentMethod.type === "ONE_CLICK" ? "Webpay OneClick" : (((ref = paymentMethod.type) === null || ref === void 0 ? void 0 : ref.replace(/_/g, "")) || "").replace(/^\w/, function(c) {
                                    return c.toUpperCase();
                                });
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                            quoteLoading: quoteLoading || loadingOneClick,
                                            onClick: function() {
                                                if (!loading && !quoteLoading) {
                                                    handleSelect(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid, paymentMethod);
                                                }
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionLeftContainer */.ox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                                            creditCardType: data.creditCardType
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                                    children: [
                                                                        data.creditCardType,
                                                                        " ••••",
                                                                        data.last4CardDigits.replace(/X+/g, " ")
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                                    light: true,
                                                                    children: "".concat(typeCapitalize)
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                        color: "primary"
                                                    })
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {})
                                    ]
                                }, paymentMethod.id);
                            }
                        })
                    }),
                    !isAssistantUser && /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                            quoteLoading: quoteLoading,
                            onClick: function() {
                                track(Interactions/* InteractionEventTypes.RedirectNewPaymentMethod */.P.RedirectNewPaymentMethod, {
                                    button_text: "Nueva tarjeta",
                                    payment_methods_registered: paymentMethods.length
                                });
                                setLoadingOneClick(true);
                                redirectToOneClick();
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionLeftContainer */.ox, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                            creditCardType: "NewCard"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                    children: "Nueva tarjeta"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                    light: true,
                                                    children: "Cr\xe9dito o d\xe9bito"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                !loadingOneClick ? /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                        color: "primary"
                                    })
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* NewCardLoaderContainer */.o3, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                                        size: 25,
                                        color: "primary"
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorModal/* ErrorModal */.k, {
                handleHideError: function() {
                    return setError(false);
                },
                uuid: "",
                errorType: ErrorModal/* ErrorModalTypes.REGISTRY */.C.REGISTRY
            })
        ]
    });
}

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/AssistantPaymentOptions.tsx






function AssistantPaymentOptions(param) {
    var loading = param.loading, handleSelect = param.handleSelect;
    var paymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOption */.Z)().paymentOption;
    var setPaymentOption = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setPaymentOption;
    var handleOnChange = function(item) {
        setPaymentOption(item);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RootDiv, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalTitleText, {
                children: "M\xe9todos de pago"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(SelectPayment, {
                placeholder: "Selecciona una opci\xf3n",
                onChange: function(item) {
                    return handleOnChange(item.target.value);
                },
                value: paymentOption,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        hidden: true,
                        value: null,
                        children: "Selecciona una opci\xf3n"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "CARD",
                        children: "Tarjeta"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectPaymentOption, {
                        value: "TRANSFER",
                        children: "Transferencia"
                    })
                ]
            }),
            paymentOption === "TRANSFER" && /*#__PURE__*/ (0,jsx_runtime.jsx)(TransferDivComponent, {}),
            paymentOption === "CARD" && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                loading: loading,
                handleSelect: handleSelect
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/hooks/useAuth.tsx + 3 modules
var useAuth = __webpack_require__(3638);
// EXTERNAL MODULE: ./src/screens/checkout/styles.ts
var checkout_styles = __webpack_require__(58055);
// EXTERNAL MODULE: ./src/validators/Events/Automatic.ts
var Automatic = __webpack_require__(21963);
;// CONCATENATED MODULE: ./src/utils/prescriptions.ts
var getHighestPrescriptionType = function(types) {
    var priority = [
        "CHECK",
        "HELD",
        "SIMPLE",
        "NOT_REQUIRED",
        null
    ];
    return types.reduce(function(highest, current) {
        if (highest === undefined || priority.indexOf(current) < priority.indexOf(highest)) {
            return current;
        }
        return highest;
    }, undefined);
};

;// CONCATENATED MODULE: ./src/screens/checkout/paymentMethod/components/PaymentsOptions.tsx




























function PaymentsOptions(param) {
    var loading = param.loading, quoteLoading = param.quoteLoading, handleNext = param.handleNext;
    var ref = (0,useAuth/* useAuth */.a)(), user = ref.appUser;
    var userCan = (0,usePermissions/* usePermissions */.T)().userCan;
    var isLocalVendor = userCan("LOCAL_VENDOR");
    var isAssistantUser = userCan("MANAGE_USER");
    var areBancoEstadoEmailsAllowed = environment/* BANCO_ESTADO_EMAILS_ALLOWED.length */.Gr.length > 0;
    var ref1;
    var isPermittedUser = areBancoEstadoEmailsAllowed ? environment/* BANCO_ESTADO_EMAILS_ALLOWED.includes */.Gr.includes((ref1 = user === null || user === void 0 ? void 0 : user.email) !== null && ref1 !== void 0 ? ref1 : "") : true;
    var track = (0,useEventTracking/* useEventTracking */.A)().track;
    var orderState = (0,useOrderState/* useOrderState */.h)();
    var orderUuid = orderState.orderUuid, currentOrder = orderState.order;
    var ref2 = (0,paymentMethodStore/* useOrderAndPaymentInfo */.oF)(), orders = ref2.orders, ordersTotal = ref2.ordersTotal, paymentMethods = ref2.paymentMethods;
    var setMixPayments = (0,localPaymentOptionsStore/* useLocalPaymentOptionsActions */.e)().setMixPayments;
    var ref3 = (0,paymentMethodStore/* usePaymentSelectors */.M6)(), mekiCreditsChecked = ref3.mekiCreditsChecked, insuranceId = ref3.insuranceId, totalReimbursement = ref3.totalReimbursement;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,useMutation/* useMutation */.D)((0,assignPaymentMethod/* assignPaymentMethod */.n)()), 1), assignMethod = ref4[0];
    var highestPrescriptionType = (0,react.useMemo)(function() {
        var ref;
        var ref1;
        return getHighestPrescriptionType((ref1 = currentOrder === null || currentOrder === void 0 ? void 0 : (ref = currentOrder.orderDetails) === null || ref === void 0 ? void 0 : ref.map(function(orderDetail) {
            var ref;
            var ref1;
            return (ref1 = orderDetail === null || orderDetail === void 0 ? void 0 : (ref = orderDetail.product) === null || ref === void 0 ? void 0 : ref.prescriptionType) !== null && ref1 !== void 0 ? ref1 : null;
        }).filter(Boolean)) !== null && ref1 !== void 0 ? ref1 : []);
    }, [
        currentOrder
    ]);
    var changePaymentAmount = (0,react.useCallback)(function(event) {
        var ref;
        var deliveryCost = (ref = orders === null || orders === void 0 ? void 0 : orders.reduce(function(acc, curr) {
            return acc + curr.deliveryCost;
        }, 0)) !== null && ref !== void 0 ? ref : 0;
        var valueToNumber = Number(event.target.value.replace("$", "").replace(/\./g, ""));
        if (Number.isInteger(+valueToNumber) && +valueToNumber <= ordersTotal - deliveryCost) {
            setMixPayments({
                CASH: +valueToNumber,
                CARD: ordersTotal - deliveryCost - +valueToNumber
            });
        }
    }, [
        orders,
        ordersTotal,
        setMixPayments
    ]);
    var handleSelect = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(e, paymentMethod, otherPaymentMethods) {
            var paymentMethodSelected, ref, ref1, uuid, insuranceIsApplicable, ref2, intallmentsRedirect, e1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        paymentMethodSelected = otherPaymentMethods == interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO ? "BANCO_ESTADO" : otherPaymentMethods == interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC ? "FINTOC" : paymentMethod.type;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        uuid = otherPaymentMethods == interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC ? "00000000-0000-0000-0000-00000001" : otherPaymentMethods == interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO ? "00000000-0000-0000-0000-00000005" : paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid;
                        return [
                            4,
                            assignMethod({
                                variables: {
                                    params: {
                                        orderUuid: orderUuid,
                                        paymentMethodUuid: uuid
                                    }
                                },
                                optimisticResponse: function optimisticResponse(param) {
                                    var paymentMethodUuid = param.params.paymentMethodUuid;
                                    var _$paymentMethod = paymentMethods.find(function(e) {
                                        return e.uuid === paymentMethodUuid;
                                    });
                                    return {
                                        assignPaymentMethod: {
                                            __typename: "Order",
                                            id: currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
                                            uuid: orderUuid,
                                            paymentMethod: {
                                                id: otherPaymentMethods == interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC ? -2 : otherPaymentMethods == interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO ? -6 : _$paymentMethod.id
                                            }
                                        }
                                    };
                                }
                            })
                        ];
                    case 2:
                        _state.sent();
                        insuranceIsApplicable = Boolean(insuranceId) && totalReimbursement != 0;
                        void track(Interactions/* InteractionEventTypes.SelectPaymentMethod */.P.SelectPaymentMethod, {
                            payment_method_type: paymentMethodSelected,
                            card_type: (ref2 = paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref = paymentMethod.data) === null || ref === void 0 ? void 0 : ref.creditCardType) !== null && ref2 !== void 0 ? ref2 : null,
                            has_meki_credits: mekiCreditsChecked,
                            has_insurance: insuranceIsApplicable
                        });
                        void track(Automatic/* AutomaticEventTypes.PrescriptionsCheckoutData */.j5.PrescriptionsCheckoutData, {
                            highest_prescription_type: highestPrescriptionType !== null && highestPrescriptionType !== void 0 ? highestPrescriptionType : null
                        });
                        intallmentsRedirect = (paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.type) === "ONE_CLICK" && [
                            "Visa",
                            "MasterCard"
                        ].includes(paymentMethod === null || paymentMethod === void 0 ? void 0 : (ref1 = paymentMethod.data) === null || ref1 === void 0 ? void 0 : ref1.creditCardType);
                        return [
                            4,
                            handleNext(intallmentsRedirect)
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        e1 = _state.sent();
                        utils/* Console.error */.Mn.error("CheckoutPaymentMethod: unhandled error", {
                            e: e1
                        });
                        utils/* Console.error */.Mn.error("CheckoutPaymentMethod: variables", {
                            paymentMethodUuid: paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.uuid,
                            orderUuid: orderUuid
                        });
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(e, paymentMethod, otherPaymentMethods) {
            return _ref.apply(this, arguments);
        };
    }(), [
        assignMethod,
        currentOrder === null || currentOrder === void 0 ? void 0 : currentOrder.id,
        handleNext,
        orderUuid,
        paymentMethods,
        mekiCreditsChecked,
        insuranceId,
        totalReimbursement,
        track,
        highestPrescriptionType, 
    ]);
    if (isLocalVendor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LocalPaymentOptions, {
            changePaymentAmount: changePaymentAmount
        });
    }
    if (isAssistantUser) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(AssistantPaymentOptions, {
            changePaymentAmount: changePaymentAmount,
            loading: loading,
            handleSelect: handleSelect
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* PaymentOptionSubSection */.Qc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_styles/* SubtitleTypography */.LE, {
                        children: "Tarjeta de cr\xe9dito/d\xe9bito"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentMethods, {
                        loading: loading,
                        quoteLoading: quoteLoading,
                        handleSelect: handleSelect
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* PaymentOptionSubSection */.Qc, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(checkout_styles/* SubtitleTypography */.LE, {
                        children: "Otros m\xe9todos de pago"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(styles/* PaymentMethodMainCard */.Z, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                quoteLoading: quoteLoading,
                                onClick: function(event) {
                                    return void handleSelect(event, null, interfaces/* OtherPaymentMethods.FINTOC */.pl.FINTOC);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionLeftContainer */.ox, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                                creditCardType: "Fintoc"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                        children: "Directo con tu banco"
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                        light: true,
                                                        children: "sin salir de la p\xe1gina"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                            color: "primary"
                                        })
                                    })
                                ]
                            }),
                            isPermittedUser && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionDiv */.q4, {
                                            quoteLoading: quoteLoading,
                                            onClick: function(event) {
                                                return void handleSelect(event, null, interfaces/* OtherPaymentMethods.BANCO_ESTADO */.pl.BANCO_ESTADO);
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* OptionLeftContainer */.ox, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CardIcon/* CardIcon */._, {
                                                            creditCardType: "BancoEstado"
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(PaymentsOptions_styles/* TextDiv */.rk, {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionTitleText */.I3, {
                                                                    children: "Banco Estado"
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* OptionDescriptionText */.ex, {
                                                                    light: true,
                                                                    children: "Compraqu\xed"
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentsOptions_styles/* ArrowIconContainer */.GF, {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowForwardIosRounded/* default */.Z, {
                                                        color: "primary"
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 52595:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ PaymentMethodMainCard; },
/* harmony export */   "b": function() { return /* binding */ PaymentMethodMiniCard; }
/* harmony export */ });
/* harmony import */ var _mui_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13264);
/* harmony import */ var _components_BaseStyles__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8347);


var PaymentMethodMiniCard = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_components_BaseStyles__WEBPACK_IMPORTED_MODULE_0__/* .MainCard */ .A)({
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 8px 8px 16px",
    maxWidth: "800px",
    width: "100%"
});
var PaymentMethodMainCard = (0,_mui_system__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_components_BaseStyles__WEBPACK_IMPORTED_MODULE_0__/* .MainCard */ .A)({
    display: "flex",
    flexDirection: "column"
});


/***/ }),

/***/ 57500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useLocalPaymentOption; },
/* harmony export */   "e": function() { return /* binding */ useLocalPaymentOptionsActions; }
/* harmony export */ });
/* harmony import */ var zustand__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(64529);

var useLocalPaymentOptionsStore = (0,zustand__WEBPACK_IMPORTED_MODULE_0__/* .create */ .Ue)()(function(set) {
    return {
        paymentOption: null,
        mixPayments: {
            CASH: 0,
            CARD: 0
        },
        actions: {
            setPaymentOption: function(to) {
                return set({
                    paymentOption: to
                });
            },
            setMixPayments: function(param) {
                var CASH = param.CASH, CARD = param.CARD;
                set({
                    mixPayments: {
                        CASH: CASH,
                        CARD: CARD
                    }
                });
            },
            cleanValues: function() {
                set({
                    paymentOption: null,
                    mixPayments: {
                        CASH: 0,
                        CARD: 0
                    }
                });
            }
        }
    };
});
var useLocalPaymentOption = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return {
            paymentOption: state.paymentOption,
            mixPayments: state.mixPayments
        };
    });
};
var useLocalPaymentOptionsActions = function() {
    return useLocalPaymentOptionsStore(function(state) {
        return state.actions;
    });
};


/***/ }),

/***/ 43472:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ useOneClickRedirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66383);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(50930);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(45680);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66252);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(50319);
/* harmony import */ var _apollo_client__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(51761);
/* harmony import */ var _queries_payment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66860);
/* harmony import */ var _queries_payment__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(50018);
/* harmony import */ var _utils_redirect__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(33756);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3638);
/* harmony import */ var _hooks_useOrderState__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(778);
/* harmony import */ var _hooks_toast_hook__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11263);
/* harmony import */ var _hooks_useSegment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59945);
/*
 * File: useOneClickRedirect.ts
 * Project: meki
 * File Created: Monday, 11th January 2021 2:59:54 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 11th November 2022 12:46:04 pm
 * Modified By: Blanca Munizaga (blanca@inventures.cl)
 * -----
 * Copyright 2019 - 2021 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 














/* Este hook se encarga de manejar todas las redirecciones de oneClick 
   y las interacciones con nuestro back-end para confirmar la inscripción de una tarjeta. */ function useOneClickRedirect() {
    var urlToRedirect = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "/pago/metodos", showError = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function() {}, handleIsRegistryError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {};
    // Hooks init
    var apolloClient = (0,_apollo_client__WEBPACK_IMPORTED_MODULE_6__/* .useApolloClient */ .x)();
    var ref = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)(), query = ref.query, replace = ref.replace;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var toasts = (0,_hooks_toast_hook__WEBPACK_IMPORTED_MODULE_4__/* .useToast */ .p)();
    var ref1 = (0,_hooks_useSegment__WEBPACK_IMPORTED_MODULE_5__/* .useSegment */ .K)(), track = ref1.track, flush = ref1.flush;
    // App state
    var ref2 = (0,_hooks_useOrderState__WEBPACK_IMPORTED_MODULE_3__/* .useOrderState */ .h)(), orderUuid = ref2.orderUuid, order = ref2.order;
    var ref3 = (0,_hooks_useAuth__WEBPACK_IMPORTED_MODULE_2__/* .useAuth */ .a)(), user = ref3.appUser;
    // Local State
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), loading = ref4[0], setLoading = ref4[1];
    // Other vars
    var finishedInscriptionRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(false);
    var ref5 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_apollo_client__WEBPACK_IMPORTED_MODULE_8__/* .useMutation */ .D)((0,_queries_payment__WEBPACK_IMPORTED_MODULE_9__/* .finishOneClickInscription */ .R)("finishOneClickPago"), {
        update: function update(cache, param) {
            var _$finishOneClickInscription = param.data.finishOneClickInscription;
            cache.modify({
                id: cache.identify((0,_apollo_client__WEBPACK_IMPORTED_MODULE_10__/* .makeReference */ .kQ)("ROOT_QUERY")),
                fields: {
                    paymentMethods: function paymentMethods(currentPaymentMethods) {
                        return [
                            _$finishOneClickInscription
                        ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(currentPaymentMethods));
                    }
                }
            });
            if (order) cache.modify({
                id: cache.identify({
                    __ref: "Order:" + String(order.id)
                }),
                fields: {
                    paymentMethod: function paymentMethod() {
                        return _$finishOneClickInscription;
                    }
                }
            });
        }
    }), 1), finishOneClickMutation = ref5[0];
    // Effects
    /**
   * Handle one click return
   */ (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!query.TBK_TOKEN || !user || finishedInscriptionRef.current) return;
        finishedInscriptionRef.current = true;
        setLoading(true);
        finishOneClickMutation({
            variables: {
                params: {
                    token: query.TBK_TOKEN,
                    orderUuid: orderUuid
                }
            }
        }).then(function(response) {
            void track("add payment succeed", {
                payment_method_type: response.data.finishOneClickInscription.type,
                userId: user === null || user === void 0 ? void 0 : user.id
            });
        }).catch(function() {
            handleIsRegistryError();
            if (showError) return showError();
            toasts.showToast({
                message: "Ocurrio un error en la inscripci\xf3n del medio de pago",
                type: "error"
            });
        }).finally(function() {
            void router.replace({
                query: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)({}, router.query), {
                    TBK_TOKEN: null
                })
            });
            setLoading(false);
        });
    }, [
        router,
        query.TBK_TOKEN,
        replace,
        finishOneClickMutation,
        orderUuid,
        user,
        toasts,
        showError,
        handleIsRegistryError,
        track, 
    ]);
    // Logic
    var getOneClickRedirectCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var ref, _data, _getRedirectUrlOneClick, url, token, method;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        apolloClient.query({
                            query: (0,_queries_payment__WEBPACK_IMPORTED_MODULE_16__/* .getOneClickRedirect */ .j)("paymentSelectOneClick"),
                            variables: {
                                params: {
                                    urlReturn: window.location.origin + "/api/oneClick?redirectPath=".concat(urlToRedirect)
                                }
                            },
                            fetchPolicy: "network-only"
                        })
                    ];
                case 1:
                    ref = _state.sent(), _data = ref.data, _getRedirectUrlOneClick = _data.getRedirectUrlOneClick, url = _getRedirectUrlOneClick.url, token = _getRedirectUrlOneClick.token, method = _getRedirectUrlOneClick.method;
                    return [
                        2,
                        {
                            url: url,
                            token: token,
                            method: method
                        }
                    ];
            }
        });
    }), [
        apolloClient,
        urlToRedirect
    ]);
    var redirectCallback = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(/*#__PURE__*/ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(function() {
        var ref, url, method, token;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_15__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    void track("add payment start", {
                        payment_method_type: "ONE_CLICK",
                        userId: user === null || user === void 0 ? void 0 : user.id
                    });
                    flush();
                    return [
                        4,
                        getOneClickRedirectCallback()
                    ];
                case 1:
                    ref = _state.sent(), url = ref.url, method = ref.method, token = ref.token;
                    (0,_utils_redirect__WEBPACK_IMPORTED_MODULE_17__/* .redirect */ .u)({
                        url: url,
                        method: method,
                        params: {
                            TBK_TOKEN: token
                        }
                    });
                    return [
                        2
                    ];
            }
        });
    }), [
        getOneClickRedirectCallback,
        track,
        flush
    ]);
    return [
        redirectCallback,
        {
            loading: loading
        }
    ];
}


/***/ }),

/***/ 33756:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ redirect; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(66383);
/*
 * File: redirect.ts
 * Project: meki
 * File Created: Monday, 21st December 2020 3:30:15 pm
 * Author: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Last Modified: Friday, 12th February 2021 1:51:27 am
 * Modified By: Gabriel Ulloa (gabriel@inventures.cl)
 * -----
 * Copyright 2019 - 2020 Incrementa Ventures SpA. ALL RIGHTS RESERVED
 * Terms and conditions defined in license.txt
 * -----
 * Inventures - www.inventures.cl
 */ 
function redirect(param) {
    var url = param.url, method = param.method, params = param.params;
    var form = document.createElement("form");
    form.style.display = "none";
    form.method = method;
    form.action = url;
    Object.entries(params).forEach(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(param, 2), key = _param[0], value = _param[1];
        var input = document.createElement("input");
        input.name = key;
        input.value = value;
        form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
}


/***/ })

}]);